import constants from '../BirthdayProductListing.constants';

export const FetchBirthdayRecommandation = (payload) => ({
  type: constants.FETCH_BIRTHDAY_RECOMMANDTIONS,
  payload,
});

export const OpenBirthdayRecommandationDrawer = (payload) => ({
  type: constants.OPEN_BIRTHDAY_RECOMMANDATION_DRAWER,
  payload,
});
